import * as api from "../api";
import {
  STORE_PROGRESS_ADD_BOOKMARK,
  STORE_PROGRESS_ADD_HIGHLIGHT,
  STORE_PROGRESS_CONTENT,
  STORE_PROGRESS_DELETE_BOOKMARK,
  STORE_PROGRESS_DELETE_HIGHLIGHT,
  STORE_PROGRESS_EDIT_BOOKMARK,
  STORE_PROGRESS_NOTES,
  STORE_PROGRESS_PROBLEMS_TRIED,
} from "../constants/actionConstants";
import {
  UPDATE_COMMENTS_USED,
  UPDATE_CONCEPTS_USED,
  UPDATE_EQUATIONS_USED,
  UPDATE_NOTES_USED,
} from "../constants/userConstants";

// export const updateProgressProblemsTried= (contentID, problemsTried) => API.patch(`/learn/${contentID}/updateProgressProblemsTried`, problemsTried ) ;

export const updateProgressFeedback =
  (contentID, sectionId, rating) => async (dispatch) => {
    try {
      console.log("Update progress feedback");
      // Send info to database (not updated locally deliberately)
      await api.updateProgressFeedback(contentID, {
        sectionId: sectionId,
        rating: rating,
      });
    } catch (error) {
      console.log(error);
    }
  };

export const updateProgressNotes = (contentID, notes) => async (dispatch) => {
  try {
    // Store which problem we have solved (will happend quickly)
    dispatch({ type: STORE_PROGRESS_NOTES, payload: notes });

    // This sends same info to database
    console.log(notes);
    await api.updateProgressNotes(contentID, notes);
  } catch (error) {
    console.log(error);
  }
};

export const updateProgressProblemsTried =
  (contentID, problemsTried, percentCompleteExercises, skipPersist = false) =>
  async (dispatch) => {
    try {
      // Store percent correct locally
      var user = JSON.parse(localStorage.getItem("profile"));
      const courseIndex = user?.result?.coursesTaken.findIndex((item) => {
        return item.courseID === contentID;
      });
      user.result.coursesTaken[courseIndex].percentCompleteExercises =
        percentCompleteExercises;
      localStorage.setItem("profile", JSON.stringify(user));

      // Store which problem we have solved (will happend quickly)
      dispatch({ type: STORE_PROGRESS_PROBLEMS_TRIED, payload: problemsTried });

      // Admins can try problems without persisting completion to the database
      if (skipPersist) return;

      // This sends same info to database
      await api.updateProgressProblemsTried(contentID, {
        problemsTried: problemsTried,
        percentCompleteExercises: percentCompleteExercises,
      });
    } catch (error) {
      console.log(error);
    }
  };

// const user = JSON.parse(localStorage.getItem('profile'))
// const coursesTaken = user?.result?.coursesTaken
// localStorage.setItem('profile', JSON.stringify({...action?.data}))

export const updateProgressContentSeen =
  (contentID, contentSeen, percentComplete) => async (dispatch) => {
    try {
      // Store percent correct locally
      var user = JSON.parse(localStorage.getItem("profile"));
      const courseIndex = user?.result?.coursesTaken.findIndex((item) => {
        return item.courseID === contentID;
      });
      user.result.coursesTaken[courseIndex].percentComplete = percentComplete;
      localStorage.setItem("profile", JSON.stringify(user));

      // Store which headings locally  (will happen quickly)
      dispatch({
        type: STORE_PROGRESS_CONTENT,
        payload: { contentLastSeen: contentSeen },
      });
      // This sends same info to database
      await api.updateProgressContentSeen(contentID, {
        contentSeen: contentSeen,
        percentComplete: percentComplete,
      });
    } catch (error) {
      console.log(error);
    }
  };

export const updateProgressElapsedTime =
  (contentID, elapsedTime, courseTitle) => async (dispatch) => {
    try {
      var user = JSON.parse(localStorage.getItem("profile"));
      // This sends same info to database
      await api.updateProgressElapsedTime(contentID, {
        elapsedTime: elapsedTime,
        courseTitle: courseTitle,
        userName: user.result.name,
      });
    } catch (error) {
      console.log(error);
    }
  };

export const updateProgressConceptsUsed = (contentID) => async (dispatch) => {
  try {
    // This is received by the reducer (will happen quickly)
    dispatch({ type: UPDATE_CONCEPTS_USED, payload: {} });
    // This sends same info to database
    await api.updateProgressConceptsUsed(contentID);
  } catch (error) {
    console.log(error);
  }
};

export const updateProgressCommentsUsed = (contentID) => async (dispatch) => {
  try {
    // This is received by the reducer (will happen quickly)
    dispatch({ type: UPDATE_COMMENTS_USED, payload: {} });
    // This sends same info to database
    await api.updateProgressCommentsUsed(contentID);
  } catch (error) {
    console.log(error);
  }
};

export const updateProgressNotesUsed = (contentID) => async (dispatch) => {
  try {
    // This is received by the reducer (will happen quickly)
    dispatch({ type: UPDATE_NOTES_USED, payload: {} });
    // This sends same info to database
    await api.updateProgressNotesUsed(contentID);
  } catch (error) {
    console.log(error);
  }
};

export const updateProgressEquationsUsed = (contentID) => async (dispatch) => {
  try {
    // This is received by the reducer (will happen quickly)
    dispatch({ type: UPDATE_EQUATIONS_USED, payload: {} });
    // This sends same info to database
    await api.updateProgressEquationsUsed(contentID);
  } catch (error) {
    console.log(error);
  }
};

export const updateProgressAddHighlight =
  (contentID, highlight) => async (dispatch) => {
    try {
      dispatch({ type: STORE_PROGRESS_ADD_HIGHLIGHT, payload: highlight });
      await api.updateProgressAddHighlight(contentID, { highlight });
    } catch (error) {
      console.log(error);
    }
  };

export const updateProgressDeleteHighlight =
  (contentID, highlightId) => async (dispatch) => {
    try {
      dispatch({ type: STORE_PROGRESS_DELETE_HIGHLIGHT, payload: highlightId });
      await api.updateProgressDeleteHighlight(contentID, { highlightId });
    } catch (error) {
      console.log(error);
    }
  };

export const updateProgressAddBookmark =
  (contentID, bookmark) => async (dispatch) => {
    try {
      // This is received by the reducer (will happen quickly)
      dispatch({ type: STORE_PROGRESS_ADD_BOOKMARK, payload: bookmark });
      // This sends same info to database
      await api.updateProgressAddBookmark(contentID, { bookmark: bookmark });
    } catch (error) {
      console.log(error);
    }
  };

export const updateProgressEditBookmark =
  (contentID, bookmark) => async (dispatch) => {
    try {
      // This is received by the reducer (will happen quickly)
      dispatch({ type: STORE_PROGRESS_EDIT_BOOKMARK, payload: bookmark });
      // This sends same info to database
      await api.updateProgressEditBookmark(contentID, { bookmark: bookmark });
    } catch (error) {
      console.log(error);
    }
  };

export const updateProgressDeleteBookmark =
  (contentID, bookmarkId) => async (dispatch) => {
    try {
      // This is received by the reducer (will happen quickly)
      dispatch({ type: STORE_PROGRESS_DELETE_BOOKMARK, payload: bookmarkId });
      // This sends same info to database
      await api.updateProgressDeleteBookmark(contentID, {
        bookmarkId: bookmarkId,
      });
    } catch (error) {
      console.log(error);
    }
  };
